<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh">Contents</p>
<p class="toc"><span href="#/xhtml/title#tit" title="Link target outside of Sample">Title Page</span></p>
<p class="toc"><span href="#/xhtml/copyrightnotice#notice" title="Link target outside of Sample">Copyright Notice</span></p>
<p class="toc-bot"><a href="#/xhtml/ded#ded">Dedication</a></p>
<p class="toc">Part 1: <a href="#/xhtml/part1#pt1">High Summer</a></p>
<p class="toc">1. <a href="#/xhtml/chapter1#ch1">Tournament Day</a></p>
<p class="toc">2. <a href="#/xhtml/chapter2#ch2">Smithfield</a></p>
<p class="toc">3. <span href="#/xhtml/chapter3#ch3" title="Link target outside of Sample">Lamastide</span></p>
<p class="toc">4. <span href="#/xhtml/chapter4#ch4" title="Link target outside of Sample">Proud Cis</span></p>
<p class="toc-bot">5. <span href="#/xhtml/chapter5#ch5" title="Link target outside of Sample">Halloween</span></p>
<p class="toc">Part 2: <span href="#/xhtml/part2#pt2" title="Link target outside of Sample">Fools’ Season</span></p>
<p class="toc">6. <span href="#/xhtml/chapter6#ch6" title="Link target outside of Sample">Night and Fogge</span></p>
<p class="toc">7. <span href="#/xhtml/chapter7#ch7" title="Link target outside of Sample">Somerset</span></p>
<p class="toc">8. <span href="#/xhtml/chapter8#ch8" title="Link target outside of Sample">Robin Hood Hill</span></p>
<p class="toc-bot">9. <span href="#/xhtml/chapter9#ch9" title="Link target outside of Sample">The Honour of Pontefract</span></p>
<p class="toc">Part 3: <span href="#/xhtml/part3#pt3" title="Link target outside of Sample">The Paper Crown</span></p>
<p class="toc">10. <span href="#/xhtml/chapter10#ch10" title="Link target outside of Sample">Wakefield</span></p>
<p class="toc">11. <span href="#/xhtml/chapter11#ch11" title="Link target outside of Sample">Sherwood</span></p>
<p class="toc">12. <span href="#/xhtml/chapter12#ch12" title="Link target outside of Sample">Nine Ladies Dancing</span></p>
<p class="toc">13. <span href="#/xhtml/chapter13#ch13" title="Link target outside of Sample">Bridge on the Dove</span></p>
<p class="toc-bot">14. <span href="#/xhtml/chapter14#ch14" title="Link target outside of Sample">The Devil’s Chair</span></p>
<p class="toc"><span href="#/xhtml/adcard#adc" title="Link target outside of Sample">Forge Books by R. Garcia y Robertson</span></p>
<p class="toc"><span href="#/xhtml/praise#pra" title="Link target outside of Sample">Praise</span></p>
<p class="toc"><span href="#/xhtml/copyright#cpt" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?411303ec